import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Building2, Save } from "lucide-react";
import DashboardShell from "@/layouts/ProviderDashboardLayout";
import api from "@/lib/api";
import { useDocumentTitle } from "@/lib/useDocumentTitle";

const FIELDS = [
  ["legal_name", "Legal business name", true],
  ["designation", "Business designation (LLC / Corp / Sole Prop)", false],
  ["ein", "EIN / Tax ID (optional)", false],
  ["billing_email", "Billing email", false],
  ["website", "Website", false],
  ["notes", "Internal notes", false],
];

export default function BusinessProfilePage() {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  useDocumentTitle("Business profile");

  useEffect(() => { api.get("/business-profile").then((r) => setForm(r.data || {})); }, []);

  const save = async () => {
    if (!form.legal_name) { toast.error("Legal name is required"); return; }
    setSaving(true);
    try {
      const { data } = await api.put("/business-profile", form);
      setForm(data);
      toast.success("Saved");
    } catch (err) { toast.error(err?.response?.data?.error || "Save failed"); } finally { setSaving(false); }
  };

  return (
    <DashboardShell>
      <div className="max-w-2xl" data-testid="business-profile">
        <div className="flex items-start justify-between gap-3 mb-6 flex-wrap">
          <div>
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#165a71]">Account</div>
            <h1 className="mt-2 font-display text-2xl md:text-3xl font-semibold text-[#071b22]">Business profile</h1>
            <p className="text-[#252A34]/70 text-sm mt-1">For business customers who need branded receipts, invoicing, or a designation on their bookings.</p>
          </div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-white p-5 space-y-3">
          {FIELDS.map(([k, l, req]) => (
            <div key={k}>
              <label className="text-xs text-[#252A34]/70">{l} {req && <span className="text-rose-500">*</span>}</label>
              <input value={form[k] || ""} onChange={(e) => setForm((p) => ({ ...p, [k]: e.target.value }))} className="mt-1 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm" data-testid={`bp-field-${k}`} />
            </div>
          ))}
          <div className="pt-2 flex justify-end">
            <button onClick={save} disabled={saving} className="inline-flex items-center gap-2 rounded-full bg-[#165a71] text-white px-4 py-2 text-sm font-medium disabled:opacity-50" data-testid="bp-save">
              <Save className="h-4 w-4" /> {saving ? "Saving…" : "Save changes"}
            </button>
          </div>
        </div>
      </div>
    </DashboardShell>
  );
}
